import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ArrowUpIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M7.47083 9.92248V1.9845C7.47083 1.7105 7.69381 1.48837 7.96888 1.48837C8.24395 1.48837 8.46693 1.7105 8.46693 1.9845V9.92248C8.46693 10.1965 8.24395 10.4186 7.96888 10.4186C7.69381 10.4186 7.47083 10.1965 7.47083 9.92248Z"
      fill="currentColor"
    />
    <path
      d="M7.61641 1.63372C7.81086 1.44002 8.12617 1.44013 8.32069 1.63372L11.6417 4.94089C11.8361 5.13453 11.8359 5.44866 11.6417 5.64244C11.4472 5.83619 11.1319 5.83619 10.9374 5.64244L7.96855 2.68507L5.00065 5.64244C4.80615 5.83619 4.49087 5.83619 4.29637 5.64244C4.10203 5.44868 4.10192 5.13458 4.29637 4.94089L7.61641 1.63372Z"
      fill="currentColor"
    />
  </svg>
);
